import React, { useState } from "react";
import "../../assets/css/SalesTrend/SalesTrend.css";
import SalesTrendHeader from "../SalesTrendHeader.tsx";
import BrandTable from "../BrandWiseSales/components/BrandTable.tsx";
import QuaterlyPerformance from "../SalesTrend/components/QuaterlyPerformance.js";
import BrandAnalysisStatus from "../BrandWiseSales/components/BrandAnalysisStatus.js";
import BrandFilter from "../BrandWiseSales/components/BrandFilter.js";
import { API_BASE_URL } from "../../config/config";
import {
  useTokenFromQuery,
  useFetchUserDetails,
  getUserIdFromToken,
} from "../../utils/dashboardUtils.js";

function NewBrandSales() {
  const [refreshTime, setRefreshTime] = useState(null);
  const [userLoaction, setuserLocation] = useState(null);
  const [headerUsername, setheaderUsername] = useState(null);

  useTokenFromQuery("/app/newbrandsales_dashboard");
  useFetchUserDetails(
    setuserLocation,
    setheaderUsername,
    setRefreshTime,
    API_BASE_URL,
    "NewBrandSalesDashboard"
  );
  const user_id = getUserIdFromToken();

  return (
    <div className="sales-trend-dashboard">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="New Brand Sales"
          userName={headerUsername}
          location={userLoaction}
          refreshTime={refreshTime}
        />

        <div className="new-filter-bar-sticky">
          <BrandFilter
            user_id={user_id}
            apiEndpoint="/Dashboard/NewBrandSalesDashboard"
            isNewBrand={true}
          />
        </div>

        <BrandAnalysisStatus
          limitedView={true}
          theadiing="Contribution To Overall Sales"
        />
        <QuaterlyPerformance />
        <BrandTable Fname="NewbrandTable_Data_Report.csv" />
      </div>
    </div>
  );
}

export default NewBrandSales;
